export default {
    intro: `Chữ cơ bản là yếu tố nhỏ nhất tạo nên từ.<br />
            Hãy cùng tìm hiểu mối quan hệ giữa từ được tạo từ Chữ cơ bản và các chữ cái nhé. `,
    options: { textbook: 'Từ trong sách giáo khoa', page: 'Sách giáo khoa' },
    header: {
        round: ({ values }: { values: { round: number } }) => {
            const { round } = values;
            return `Chữ ${round === 1 ? 'thứ nhất' : 'thứ hai'}`;
        },
        title: {
            word: 'Chữ',
            example1: 'Ví dụ từ 1',
            example2: 'Ví dụ từ 2',
            check: 'Kiểm tra từ đã học',
            question: 'Câu hỏi từ vựng',
            meaning: 'Kiểm tra mối quan hệ ý nghĩa',
            meaningQuestion: 'Câu hỏi quan hệ ý nghĩa',
        },
    },
    indicator: {
        word: 'Học hình dạng, âm thanh và ý nghĩa của Chữ cơ bản.',
        example1: 'Học cách Chữ cơ bản được sử dụng trong từ.',
        example2: 'Học cách Chữ cơ bản được sử dụng trong từ.',
        check: 'Học hai từ có chứa Chữ cơ bản.',
        question: 'Trong hai từ, từ nào sử dụng chữ "{ reading }({ cn })"?',
        meaning: 'Học cách Chữ cơ bản được sử dụng trong từ.',
        meaningQuestion: 'Mối quan hệ giữa { first } và { second } là gì?',
        // Câu giải thích mối quan hệ theo loại (0 đồng nghĩa / 1 trái nghĩa / 2 bao hàm / 3 đồng tự / 4 đa nghĩa)
        desciption: {
            0: '<strong>{ first }</strong> và <strong>{ second }</strong> có nghĩa giống nhau.',
            1: '<strong>{ first }</strong> và <strong>{ second }</strong> có nghĩa trái ngược nhau.',
            2: '<strong>{ first }</strong> bao hàm nghĩa của <strong>{ second }</strong>.',
            3: '<strong>{ first }</strong> và <strong>{ second }</strong> đều đọc là { sound } nhưng có nghĩa khác nhau.',
            4: '<strong>{ first }</strong> vừa có nghĩa là <strong>{ meaning1 }</strong>, vừa có nghĩa là <strong>{ meaning2 }</strong>.',
        },
    },
    toast: {
        cube: ({ values }: { values: { isTeacher: boolean } }) => {
            const { isTeacher } = values;
            return isTeacher
                ? 'Đây là phần Học sinh tự xoay khối lập phương để học.'
                : 'Hãy tự xoay khối lập phương để học chữ cái nhé.';
        },
        wrongAnswer: {
            lead: 'Cùng suy nghĩ lại nhé?',
            body: 'Hãy nhìn vào nghĩa và chọn từ phù hợp.',
        },
    },

    description: ({ values }: { values: { type: number } }) => {
        const { type } = values;
        if (type === 0) {
            return 'Đồng nghĩa';
        }
        if (type === 1) {
            return 'Trái nghĩa';
        }
        if (type === 2) {
            return 'Bao hàm';
        }
        if (type === 3) {
            return 'Đồng tự';
        }
        if (type === 4) {
            return 'Đa nghĩa';
        }
        if (type === 5) {
            return 'Không có';
        }
        return 'Không có';
    },
    relationResult: {
        lead: 'Mối quan hệ như thế này được gọi là',
        tail: () => '.',
    },
    result: { correct: 'Đúng', incorrect: 'Sai', selected: 'Đã chọn' },
    buttons: {
        next: 'Tiếp theo',
        learn: 'Học từ vựng',
        nextLearn: 'Từ tiếp theo',
        collectWord: 'Xem lại các từ',
        check: 'Kiểm tra từ đã học',
        seoncdLearn: 'Học chữ thứ hai',
        relation: 'Học quan hệ ý nghĩa',
        prev: 'Quay lại',
        finishStudy: 'Hoàn thành học tập',
        desciption: 'Xem giải thích',
    },
    guide: {
        cube: 'Nhấp vào khối lập phương để xoay.',
    },
    study: {
        example: 'Câu ví dụ',
        meaning: 'Nghĩa',
    },
};
